// Official MUSORA wordmark: the uploaded original files, untouched (no redraw, no recolor). The artwork has empty margins inside the
// file: the frame crops them with CSS only (1560×300 px area at x=230, y=230 of the 2000×729 file: the drawn pixels are 241-1783 × 241-521).
const TRANSPARENT = "/brand/musora-logo-trasparente.webp";
const ON_WHITE = "/brand/musora-logo-bianco.webp";

function Wordmark({ src, height }) {
  return (
    <span className="block overflow-hidden" style={{ height, aspectRatio: "1560 / 300" }}>
      <img src={src} alt="MUSORA" draggable={false} className="block max-w-none select-none"
        style={{ width: "128.21%", marginLeft: "-14.74%", marginTop: "-14.74%" }} />
    </span>
  );
}

// dark: on navy surfaces the navy letters would vanish, so the white-background original sits on its own white plate
export function Logo({ dark = false, height = 22 }) {
  return (
    <span className="inline-flex items-center" data-testid="app-logo">
      {dark
        ? <span className="inline-flex rounded-lg bg-white px-3 py-2 shadow-sm ring-1 ring-white/10" data-testid="app-logo-plate"><Wordmark src={ON_WHITE} height={height} /></span>
        : <Wordmark src={TRANSPARENT} height={height} />}
    </span>
  );
}
